import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { Select, FormControl, MenuItem } from '@mui/material'

import 'bootstrap/dist/css/bootstrap.min.css';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import LoadingOverlay from 'react-loading-overlay';

import MuiDialogAlert from '../components/MuiDialogAlert';
import RoomsAutoComplete from '../components/RoomsAutoComplete';

import { epochToDate, epochToTime, todayEpochStart, todayEpochEnd, getTodayDate } from '../components/Functions'


const axios = require('axios').default;

var timezone_offset = 8 * 60 * 60
var defaultDate = getTodayDate();


const columns = [
  { field: 'date', headerName: 'Date' },
  { field: 'time', headerName: 'Time' },
  { field: 'description', headerName: 'Station', width: 150 },
  { field: 'room_id', headerName: 'Room ID', width: 150 },
  { field: 'weight_01', headerName: 'General Waste (g)', width: 100 },
  { field: 'weight_02', headerName: 'Disposables (g)', width: 100 },
  { field: 'weight_03', headerName: 'Plastic (g)', width: 100 },
  { field: 'weight_04', headerName: 'Metal (g)', width: 100 },
  { field: 'weight_05', headerName: 'Paper (g)', width: 100 }
]



function RoomActivity() {

  const [loadingActive, setLoadingActive] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading"); 
  const [modalHeader, setModalHeader] = useState("");

  const [modalBody, setModalBody] = useState("Update Successful");
  const [showModal, setShowModal] = useState(false);

  const [genBtnDisable, setGenBtnDisable] = useState(true);
  const [floorSelectDisable, setFloorSelectDisable] = useState(true);
  const [blockSelectDisable, setBlockSelectDisable] = useState(true);

  const [showRoomFilter, setShowRoomFilter] = useState("");
  const [showRoomSearch, setShowRoomSearch] = useState("hidden");
  const [showDataDiv, setShowDataDiv] = useState("hidden")

  const [rcList, setRcList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [roomList, setRoomList] = useState(false);

  const [transData, setTransData] = useState([]);

  const [rcValue, setRcValue] = useState("");
  const [blockValue, setBlockValue] = useState("");
  const [floorValue, setFloorValue] = useState("");
  const [searchRoomValue, setsearchRoomValue] = useState("");
  const [fromDateValue, setFromDateValue] = useState(todayEpochStart());
  const [toDateValue, setToDateValue] = useState(todayEpochEnd());


  const handleClose = () => setShowModal(false);
  let navigate = useNavigate();

  // Load all the available Rooms into the autocomplete component
  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_parameters";
    setLoadingActive(true);

    axios.post(url, {
      "api_user": JSON.parse(localStorage.getItem('user')),
      "parameters": "RoomList"
    })
      .then(function (response) {
        let data = response.data;
        
        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }
        setRoomList(
          data.map((d) => {
            return (d.room_id)
          }
          ))

        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error loading Room List")
        setModalBody(error)
        setShowModal(true)
      });
  }, [])

  // Load the available RCs into the select menu
  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_parameters";
    setLoadingActive(true);

    axios.post(url, {
      "api_user": JSON.parse(localStorage.getItem('user')),
      "parameters": "RcList"
    })
      .then(function (response) {

        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        setRcList(response.data)
        if (response.data.length > 0) {
          setRcValue("all_rcs")
        }
        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error Loading RC List")
        setModalBody(error)
        setShowModal(true)
      });
  }, [])

  // Load the available blocks into the select menu when the user selects a RC
  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_parameters";
    setLoadingActive(true);

    if (rcValue === "all_rcs") { // Disable selecting of Blocks and floors 
      setBlockSelectDisable(true)
      setBlockValue("all_blocks")
      setLoadingActive(false)
    }
    else{
      axios.post(url, {
        "api_user": JSON.parse(localStorage.getItem('user')),
        "parameters": "BlockList",
        "rc_code": { rcValue }
      })
        .then(function (response) {
          if (response.data.status === "API_AUTH_ERROR") {
            // Force user to re-login if unable to autheticate with the API
            navigate("/logout")
          }
          
          setBlockList(response.data)
          setLoadingActive(false)
          if (response.data.length > 0) {
            setBlockValue("all_blocks")
            setBlockSelectDisable(false)
          }
        })
        .catch(function (error) {
          setModalHeader("Error loading Block List")
          setModalBody(error)
          setShowModal(true)
        });
    }
  }, [rcValue])

  // Load the available floors into the select menu when the user selects a BLOCK
  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_parameters";
    setLoadingActive(true);

    if (blockValue === "all_blocks"){ // Disable selecting of floors if the user selects all blocks
      setFloorSelectDisable(true)
      setFloorValue("all_floors")
      setLoadingActive(false)
    }
    else{ 
      axios.post(url, {
        "api_user": JSON.parse(localStorage.getItem('user')),
        "parameters": "FloorList",
        "rc_code": { rcValue },
        "block_code": { blockValue }
      })
        .then(function (response) {
          if (response.data.status === "API_AUTH_ERROR") {
            // Force user to re-login if unable to autheticate with the API
            navigate("/logout")
          }
          
          setFloorList(response.data)
          if (response.data.length > 0) {
            setFloorValue("all_floors")
            setFloorSelectDisable(false)
          }
          setLoadingActive(false)
        })
        .catch(function (error) {
          setModalHeader("Error loading Floor List")
          setModalBody(error)
          setShowModal(true)
        });
    }

  }, [blockValue])

  // Disable the Generate button if the search by room ID is on
  useEffect(() => {
    if (showRoomSearch !== "hidden") { // Search room option is active
      if (searchRoomValue !== "") {
        setGenBtnDisable(false)
      }
      else {
        setGenBtnDisable(true)
      }
    }
  }, [showRoomSearch, searchRoomValue])

  // Disable the search button if the filter room option is on
  useEffect(() => {
    if (showRoomFilter !== "hidden") { // Filter room option is active
      setGenBtnDisable(false)
    }
  }, [showRoomFilter])


  function genBtnClick() {

    let post_data = {
      "api_user": JSON.parse(localStorage.getItem('user'))
    }

    if (showRoomSearch !== "hidden") { // Room Search is active
      post_data.parameters = "RoomSearch"
      post_data.room_id = searchRoomValue
      post_data.from_date = fromDateValue
      post_data.to_date = toDateValue
    }

    if (showRoomFilter !== "hidden") { // Room Filter is active
      post_data.parameters = "RoomFilter"
      post_data.rc_code = rcValue
      post_data.block_code = blockValue
      post_data.floor_code = floorValue
      post_data.from_date = fromDateValue
      post_data.to_date = toDateValue
    }


    let url = process.env.REACT_APP_API_SERVER + "/gen_report";
    setLoadingActive(true);

    axios.post(url, post_data)
      .then(function (response) {
        let data = response.data;
        
        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        if (data.status === "OK") {
          let tmp_array = []

          data.trans_data.map((trans) => {
            let tmp = {};
            tmp.id = trans.id
            tmp.station_id = trans.station_id
            tmp.description = trans.description
            tmp.room_id = trans.room_id
            tmp.date = epochToDate(trans.epoch)
            tmp.time = epochToTime(trans.epoch)
            tmp.weight_01 = trans.weight_01
            tmp.weight_02 = trans.weight_02
            tmp.weight_03 = trans.weight_03
            tmp.weight_04 = trans.weight_04
            tmp.weight_05 = trans.weight_05

            tmp_array.push(tmp);
          })
          setTransData(tmp_array)
          setShowDataDiv("")
        }


        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error: Unable to Generate Report")
        setModalBody(error)
        setShowModal(true)
      });


  }

  // Update required states when a user input changes
  function updateForm(e) {
    let id = e.target.id ?? "";

    if (e.target.name === "rc") {
      setRcValue(e.target.value)
    }

    if (e.target.name === "block") {
      setBlockValue(e.target.value)
    }

    if (e.target.name === "floor") {
      setFloorValue(e.target.value)
    }

    if (id.includes("roomId")) {
      setsearchRoomValue(e.target.innerHTML)
    }

    if (id === "from_date") {
      let tmp = (e.target.valueAsNumber / 1000) - timezone_offset
      setFromDateValue(tmp)
    }

    if (id === "to_date") {
      let tmp = (e.target.valueAsNumber / 1000) - timezone_offset + (24 * 60 * 60) - 1
      setToDateValue(tmp)
    }
  }

  // Toggle between Search and Filter options
  function displaySearchOptions(e) {

    if (e.target.value === "search") {
      setShowRoomSearch("")
      setShowRoomFilter("hidden")
    }

    if (e.target.value === "filter") {
      setShowRoomSearch("hidden")
      setShowRoomFilter("")
    }
  }


  return (
    <div align="left" style={{ height: "100%" }}>
      <LoadingOverlay
        active={loadingActive}
        spinner
        text={loadingText}
        className="spinner_div"
      >
        <div className="form_area">

          <div className="form-labels">
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="filter"
              name="radio-buttons-group"
              size="small"
              onChange={displaySearchOptions}
              variant="outlined"

            >
              <FormControlLabel value="filter" control={<Radio />} label="Filter by Room Location" />
              <FormControlLabel value="search" control={<Radio />} label="Search by Room ID" />
            </RadioGroup>
          </div>

          <div>
            <table>
              <tr>
                <td valign="top">
                  <div className={showRoomFilter}>
                    <table>
                      <tr>
                        <td>
                          <div className="form-labels">RC/Hall</div>
                          <FormControl fullWidth>
                            <Select
                              id="rc"
                              name="rc"
                              label="Select RC"
                              value={rcValue}
                              variant="outlined"
                              onChange={updateForm}
                              sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                ' & .MuiSelect-select': { fontSize: 14 }
                              }}
                            >
                              <MenuItem key="0" value="all_rcs">All RCs/Halls</MenuItem>
                              {
                                rcList.map(rc => {
                                  return <MenuItem key={rc.rc_code} value={rc.rc_code}>
                                    {rc.description}
                                  </MenuItem>
                                })
                              }
                            </Select>
                          </FormControl>
                        </td>
                        <td width="15px"></td>
                        <td>
                          <div className="form-labels">Block</div>
                          <FormControl fullWidth>
                            <Select
                              id="block"
                              name="block"
                              label="Select Block"
                              onChange={updateForm}
                              value={blockValue}
                              disabled={blockSelectDisable}
                              style={{ width: "150px" }}
                              sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                ' & .MuiSelect-select': { fontSize: 14 }
                              }}
                            >
                              <MenuItem key="0" value="all_blocks">All Blocks</MenuItem>
                              {
                                blockList.map(block => {
                                  return <MenuItem key={block.block_code} value={block.block_code}>
                                    {block.description}
                                  </MenuItem>
                                })
                              }
                            </Select>
                          </FormControl>

                        </td>
                        <td width="15px"></td>
                        <td>
                          <div className="form-labels">Floor</div>
                          <FormControl fullWidth>
                            <Select
                              id="floor"
                              name="floor"
                              label="Select Floor"
                              // size="small"
                              onChange={updateForm}
                              value={floorValue}
                              disabled={floorSelectDisable}
                              style={{ width: "150px" }}
                              sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                ' & .MuiSelect-select' : {fontSize: 14}
                              }}
                            >
                              <MenuItem key="0" value="all_floors">All Floors</MenuItem>
                              {
                                floorList.map(floor => {
                                  return <MenuItem key={floor.floor_code} value={floor.floor_code}>
                                    {floor.description}
                                  </MenuItem>
                                })
                              }

                            </Select>
                          </FormControl>
                        </td>
                        <td width="15px"></td>
                      </tr>


                    </table>
                  </div>
                  <div className={showRoomSearch}>
                    <table>
                      <tr>
                        <td>
                          <div className="form-labels">Room ID</div>
                          <RoomsAutoComplete
                            id="roomId"
                            data_list={roomList}
                            onChangeFunc={updateForm}

                          />
                        </td>
                        <td width="15px"></td>
                      </tr>
                    </table>
                  </div>
                </td>
                <td>
                  <div className="form-labels">Start Date</div>

                  <TextField
                    id="from_date"
                    type="date"
                    defaultValue={defaultDate}
                    onChange={updateForm}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    sx={{
                      '& legend': { display: 'none' },
                      '& fieldset': { top: 0 },
                      '& .MuiInputBase-input': { fontSize: 14 }
                    }}
                  />
                </td>
                <td width="15px"></td>
                <td>
                  <div className="form-labels">End Date</div>

                  <TextField
                    id="to_date"
                    type="date"
                    defaultValue={defaultDate}
                    onChange={updateForm}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    sx={{
                      '& legend': { display: 'none' },
                      '& fieldset': { top: 0 },
                      '& .MuiInputBase-input': { fontSize: 14 }
                    }}
                  />
                </td>
                <td width="15px"></td>
                <td>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={genBtnClick}
                    sx={{ width: 100, height: 50 }}
                    disabled={genBtnDisable}
                    style={{ marginTop: "20px" }}
                  >
                    Generate
                  </Button>
                </td>
              </tr>
            </table>

            <div style={{ height: "30px"}}></div>

            <div className={showDataDiv}>
              <div style={{ height: 700, width:"100%" }}>
                <DataGrid
                  rows={transData}
                  columns={columns}
                  pageSize={50}
                  disableVirtualization
                  disableSelectionOnClick
                  components={{ Toolbar: GridToolbar }}
                  sx={{
                    '& .MuiTablePagination-selectLabel': { 
                      paddingTop: '15px' 
                      
                    },
                    '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                    '& .MuiDataGrid-cell' : { fontSize: 12 },
                    '& .MuiDataGrid-columnHeader' : { fontSize: 12 }

                  }}                />
              </div>
            </div>


          </div>

          <MuiDialogAlert
            showModal={showModal}
            handleClose={handleClose}
            bodyContent={modalBody}
            title={modalHeader}
            bodyClass="whitespace"
          />


        </div>
      </LoadingOverlay>
    </div>
  )
}

export default RoomActivity